let currentUser;
// Function to set the user's data
export function setUserData(user) {
    currentUser = user;
}
// Function to get the user's data
export function getUserData() {
    return currentUser;
}
